var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.banners && _vm.banners.length > 0)?_c('div',_vm._l((_vm.banners),function(childBlok){return _c('StoryblokComponent',{key:childBlok._uid,attrs:{"blok":childBlok}})}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }